export const updatePasswordMutation = `mutation updatePassword($account_id: ID!, $password: String) {  
    updatePassword(account_id: $account_id, password: $password) {
      id
    }
  }
  `;
